export default {
      id: "marker-filter-usage",
      viewBox: "0 0 20 25",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#marker-filter",
      toString: function () {
        return this.url;
      }
    }